/**
 * @license BCP
 * (c) 2015 Openprovider. http://openprovider.eu
 * @author Igor Dolzhikov idolzhikov@openprovider.nl
 * License: MIT
 */
(function() {'use strict';

angular.module("promotions")
  /**
 * @ngdoc directive
 * @name ruleDetails
 *
 * @description
 * Details of the rule element
 */
  .directive("ruleDetails", function () {
    return {
      restrict: "E",
      scope: {
        item: '@',
        title: '@',
        details: '@',
      },
      templateUrl: "promotions/rule-details.html",
    };
  });

})();
